import React, { Component } from 'react';
import {StyleSheet, Text, View, Animated, Easing, Image, Pressable} from 'react-native';

import TaskImages from './Images';

const fps = 60;
const fpsDuration = 1000/fps;
const fpsPecent = 1/fps;
const MYEPSILON = 0.0001;

class CodeAnim extends Component {
  constructor(props) {
    super(props);

    this.state = {
      image: null,
    }

  }
  
  codeAnim = new Animated.Value(0);
  codeInterpolateX =
    this.codeAnim.interpolate({
      //inputRange: [0, 1, 2, 3, 4],
      //outputRange: [200, 220, 200, 180, 200]
	  inputRange: [0, 1],
      outputRange: [210, 190]
    });
	
	codeInterpolateY =
    this.codeAnim.interpolate({
      //inputRange: [0, 1, 2, 3, 4],
      //outputRange: [200, 180, 200, 220, 200]
	  inputRange: [0, 1],
      outputRange: [190, 210]
    });

  changeImage(newImage) {
	  if (this.looping) {
		  this.looping.stop();
	  }
	  this.codeAnim.setValue(0);
	   this.looping = Animated.loop(
		 Animated.timing(
		   this.codeAnim,
		   {
			 toValue: 1,
			 duration: 500,
			 //easing: Easing.linear,
			 easing: (t: number) => {
				 if (Math.round(t*2) % 2 == 0) {
					 return 0;
				 }
				 else {
					 //return Math.round(t*4)/4;
					 return 1;
				 }
			 },
			 useNativeDriver: false,
		   }
		 )
	   ).start();	  
	  
	  
	  this.setState({image: newImage});
  }
  
  

  render() {
	  if (this.state.image) {
		return (
			<View style={styles.viewAnimation}>
				<Animated.Image style={{alignSelf: 'center', resizeMode: 'stretch', height: this.codeInterpolateX, width: this.codeInterpolateY}} source={TaskImages[this.state.image]} />
			</View>
		);
	  }
	  return null;
  }
}

const styles = StyleSheet.create({
  viewAnimation: {
	  //flex: 1,
	  alignContent: 'center',
	  justifyContent: 'center',
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  width: '100%',
	  height: '100%',
  },
  codeAnimation: {
	  //flex: 1,
	  alignSelf: 'center',
	  //justifyContent: 'center',
	  //position: 'absolute',
	  //left: '50%',
	  //top: '50%',
  },
});

export default CodeAnim;